var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { ref: "themesEditorTabs", staticClass: "d-flex align-items-center py-1" },
    _vm._l(_setup.editors, function (editor, index) {
      return _c(_setup.ThemesEditorTab, {
        key: index,
        attrs: { editor: editor, index: index },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }